// extracted by mini-css-extract-plugin
export var dates = "CruiseSegmentSummary-module--dates--285cb";
export var map = "CruiseSegmentSummary-module--map--2d406";
export var mapContainer = "CruiseSegmentSummary-module--map-container--2ffc0";
export var name = "CruiseSegmentSummary-module--name--951c4";
export var root = "CruiseSegmentSummary-module--root--94ad6";
export var title = "CruiseSegmentSummary-module--title--5bcde";